import styled from 'styled-components';

export const AlertIcon = styled.div<{
  styling: { padding: string; height: string; width: string };
}>`
  display: block;
  position: absolute;
  top: ${({ styling }) => styling.padding};
  right: ${({ styling }) => styling.padding};
  height: ${({ styling }) =>
    `calc((${styling.height} - ${styling.padding} * 2) * 0.375)`};
  width: ${({ styling }) =>
    `calc((${styling.width} - ${styling.padding} * 2) * 0.375)`};
  background: #8f17d1;
  border-radius: 50%;
`;
